import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../Components/Button'
import Navbar from '../../Components/Navbar'
export default class GameOver extends React.Component {
    render() {
        return (
            <>
                <header>
                    <Navbar/>
                </header>
                <main className="main">
                    <div className="game-over-prompt">
                        <h1>Game is Over !</h1>
                        <div className="game-over-container">
                            <h2>Your Score is {this.props.score}</h2>
                            <Button click={this.props.click} btn="other-button" number="Play Again"></Button>
                            <Link to="/schulteHome"><Button btn="other-button" number="Back"></Button></Link>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}